export default {
    getSession() {
        const sidFormat = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx';
        let d = new Date().getTime();
        const uuid = sidFormat.replace(/[xy]/g, (c) => {
            // eslint-disable-next-line no-bitwise
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            // eslint-disable-next-line no-bitwise
            return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
        });
        return uuid;
    },
    generateGuid() {
        return `${this.s4() + this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}${this.s4()}${this.s4()}`;
    },
    s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    },
    generateUniqueId() {
        return (this.s4() + this.s4() + this.s4()).substring(2);
    },
    getTokenList(destinationUrl, tokenValues) {
        const tokenList = [];
        if (destinationUrl.indexOf('{sidNoDash}') > -1) {
            tokenList.push({ key: '{sidNoDash}', value: tokenValues.sid });
        } else if (destinationUrl.indexOf('{sid}') > -1) {
            tokenList.push({ key: '{sid}', value: tokenValues.sid });
        }
        tokenList.push({ key: '{uniqueId}', value: tokenValues.sid });
        tokenList.push({ key: '{amount}', value: tokenValues.amount });
        tokenList.push({ key: '{state}', value: tokenValues.state });
        tokenList.push({ key: '{mtaId}', value: tokenValues.mtaid });
        tokenList.push({ key: '{formId}', value: tokenValues.qFormId });
        // Check if url contains clickid
        if (destinationUrl.indexOf('{clickid}') > -1) {
            tokenList.push({ key: '{clickid}', value: tokenValues.clickId });
        }
        // Check if url contains zipcode
        if (destinationUrl.indexOf('{zipcode}') > -1) {
            tokenList.push({ key: '{zipcode}', value: tokenValues.zipCode });
        }
        // Check if url contains Currently Insured
        if (destinationUrl.indexOf('{prior}') > -1) {
            tokenList.push({ key: '{prior}', value: tokenValues.currentlyInsured });
        }
        return tokenList;
    },
    matchToken(key, value, url) {
        const keyRegEX = new RegExp(key, 'ig');
        if (url && url.match(keyRegEX)) {
            if (typeof value !== 'undefined' && value !== null && value !== '') {
                return url.replace(keyRegEX, value);
            }
            return url.replace(keyRegEX, '');
        }
        return url;
    },
    tokenReplacement(tokenList, url) {
        if (typeof url !== 'string') {
            return '';
        }

        let resultUrl = url;

        for (let indx = 0; indx < tokenList.length; indx++) {
            resultUrl = this.matchToken(tokenList[indx].key, tokenList[indx].value, url);
        }
        return resultUrl;
    },
    getPerprimeSid(destinationUrl) {
        let sid;
        if (destinationUrl.indexOf('{sidNoDash}') > -1) {
            sid = this.getSession();
        } else if (destinationUrl.indexOf('{sid}') > -1) {
            sid = this.generateGuid();
        } else if (destinationUrl.indexOf('{uniqueId}') > -1) {
            sid = this.generateUniqueId();
        }
        return sid;
    },
};
